/*export const ROOT_URL = "http://localhost:5006";
export const LOGIN_REDIRECT = "http://localhost:3001/login?redirectUrl=http://localhost:3000";
export const LOGIN_REDIRECT_TO = "http://localhost:3001/login?redirectUrl=";
export const MY_ACCOUNT = "http://localhost:3001";
*/
export const ROOT_URL = "https://console.topworks.vn";
export const MY_ACCOUNT = "https://me.topworks.vn";
export const LOGIN_REDIRECT = "https://me.topworks.vn/login?redirectUrl=https://topworks.vn";
export const LOGIN_REDIRECT_TO = "http://me.topworks.vn/login?redirectUrl=";
